import React, { useCallback, useEffect, useReducer } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import Summary from "./partials/Summary";
import { useCookies } from "react-cookie";
import { getListReward } from '../../../controller/api/__classic__/reward'
import { calculatePage } from "../../../helper/helper";

export const Context = React.createContext(null);

const initialData = {
  filter: {
    from: new Date(),
    to: new Date(),
    phone: '',
    region: 'ALL',
    page: 0
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  filterPressCount: 0,
  isLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        }
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        }
      }
    case 'UPDATE_REGION':
      return {
        ...state,
        filter: {
          ...state.filter,
          region: action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: Boolean(action.payload)
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['lottmekong'])

  const getAllFunc = useCallback(async () => {
    dispatch({ type: 'SET_LOADING', payload: true })
    
    try {
      let phone = state.filter.phone || ''

      if (phone && phone.indexOf('MB') < 0) {
        phone = phone.replace('0', '+84')
      }

      const response = await getListReward(cookies.lottmekong, {
        from: state.filter.from,
        to: state.filter.to,
        phone: phone,
        region: state.filter.region
      }, state.filter.page)

      if (response) {
        dispatch({
          type: 'UPDATE_DATA',
          payload: {
            list: response.data,
            total: response.total,
            totalPage: calculatePage(response.total)
          }
        })
      }
    } finally {
      dispatch({ type: 'SET_LOADING', payload: false })
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.page, state.filter.phone, state.filter.region])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc, state.filterPressCount, state.filter.page, state.filter.region])

  useEffect(() => {
    document.title = 'Trúng thưởng Truyền thống'
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <Summary />

      <Table />
    </Context.Provider>
  );
};
